export default __webpack_public_path__ + "static/media/drive.365bb79f.png";